import React, { Component } from 'react';
import ReactTable from 'react-table';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { Collapse } from 'reactstrap';
import 'react-table/react-table.css';
import 'react-dates/lib/css/_datepicker.css';
import TableFamily from '../../Components/Table-Family/Table-Family';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import Usuario from '../../Utils/Usuario';
import InputMask from 'react-input-mask';
import { Link, NavLink } from 'react-router-dom';
import Geral from '../../Utils/Geral';
import "./Client-Orders.scss";
import DivPermission from '../../Components/Div-Permission/Div-Permission';
import ModalEndereco from '../../Components/Modal-Endereco/Modal-Endereco';
import update from 'immutability-helper';



class ClientOrders extends Component {

    constructor() {
        super();

        this.getOrders = this.getOrders.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.formataTelefone = this.formataTelefone.bind(this);
        this.productBadgeType = this.productBadgeType.bind(this);
        this.atualizaDados = this.atualizaDados.bind(this);
        this.toggleModalAtualizacao = this.toggleModalAtualizacao.bind(this);
        this.carregaInfosMembro = this.carregaInfosMembro.bind(this);
        this.cadastrarCile = this.cadastrarCile.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.botaoLogarHub = this.botaoLogarHub.bind(this);
        this.botaoLogarCile = this.botaoLogarCile.bind(this);
        this.tipoBadgeLogin = this.tipoBadgeLogin.bind(this);
        this.carregaListaHistoricoAvisos = this.carregaListaHistoricoAvisos.bind(this);
        this.refreshTableHistoricoAvisos = this.refreshTableHistoricoAvisos.bind(this);
        this.toggleModalEditarDados = this.toggleModalEditarDados.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.salvarEdicaoDados = this.salvarEdicaoDados.bind(this);
        this.validacaoDtNascimento = this.validacaoDtNascimento.bind(this);
        this.validacaoEmail = this.validacaoEmail.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.carregarEnderecos = this.carregarEnderecos.bind(this);
        this.reativarCadastro = this.reativarCadastro.bind(this);
        this.toggleModalEndereco = this.toggleModalEndereco.bind(this);
        this.marcarEnderecoPadrao = this.marcarEnderecoPadrao.bind(this);
        this.excluirEndereco = this.excluirEndereco.bind(this);
        this.toggleCollapseSenha = this.toggleCollapseSenha.bind(this);
        this.toggleModalConfirmarSenha = this.toggleModalConfirmarSenha.bind(this);
        this.apiGerarSenha = this.apiGerarSenha.bind(this);
        this.reenviarLink = this.reenviarLink.bind(this);
        this.redefinirSenha = this.redefinirSenha.bind(this);
        this.alterarCPF = this.alterarCPF.bind(this);
        this.salvarNovoCPF = this.salvarNovoCPF.bind(this);
        this.cancelar = this.cancelar.bind(this);
        this.validaCPF = this.validaCPF.bind(this);
        this.mostrarMascaraCPF = this.mostrarMascaraCPF.bind(this);
        this.carregaListaHistoricoUsuario = this.carregaListaHistoricoUsuario.bind(this);
        this.refreshTableHistoricoUsuario = this.refreshTableHistoricoUsuario.bind(this);
        this.enviarDadosRightNow = this.enviarDadosRightNow.bind(this);
        this.toggleModalDadosEnviados = this.toggleModalDadosEnviados.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            isLoadingDetalhes: true,
            isLoadingAtualizacao: false,
            modalAtualizacao: false,
            hasError: false,
            errorMessage: '',
            isLoadingLogar: false,
            isLoadingLogarCile: false,
            isLoadingHistoricoAvisos: false,
            userBalance: 0,
            modalEditarDados: false,
            isLoadingEdicaoDados: false,
            dtNascimento: '',
            email: '',
            temAlteracao: false,
            isOpen: false,
            flagDtNascimentoInvalido: false,
            flagEmailInvalido: false,
            enderecos: [],
            isLoadingEnderecos: true,
            isLoadingReativacao: false,
            modalEndereco: false,
            loadingExcluirEndereco: false,
            loadingEnderecoPadrao: false,
            open: false,
            modalConfirmarSenha: false,
            flagSenhaGerada: false,
            isLoadingSenhaGerada: false,
            isLoadingReenviarLink: false,
            senhaConfirmada: false,
            isLoadingConfirmarSenha: false,
            inputEmailReenvio: "",
            flagAlterarCPF: false,
            sucessoCPFAlterado: false,
            isLoadingSalvarNovoCPF: false,
            cpfAlterado: '',
            loadingListaHistoricoUsuario: false,
            isLoadingEnviarDados: false,
            modalDadosEnviados: false
        };

        this.columnsPedidos = [
            {
                Header: 'Pedido',
                accessor: 'numeroPedido',
                className: 'text-center pointer',
                width: 80
            },
            {
                Header: 'Solicitante',
                className: 'pointer',
                accessor: 'nomeSolicitante',

            },
            {
                Header: 'Cod.Membro',
                accessor: 'codMembroSolicitante',
                className: 'text-center pointer',
                width: 100,
                Cell: row => (<span className={row.value ? '' : 'badge badge-secondary'}> {row.value ? row.value : 'Não membro'}</span>)

            },
            {
                Header: 'Valor',
                accessor: 'valorPedido',
                className: 'text-center pointer',
                width: 100,
                Cell: row => (<span>R$ {row.value !== undefined && row.value !== null ? row.value.toFixed(2).toString().replace('.', ',') : "0,00"}</span>)
            },
            {
                Header: 'Dt. pedido',
                accessor: 'dtPedido',
                className: 'pointer text-center',
                width: 100,
                Cell: row => (<span>{moment(row.value).format('DD/MM/YY')}</span>)
            },
            {
                Header: 'Dt. pagto.',
                accessor: 'dtPagto',
                className: 'pointer text-center',
                width: 100,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY') : '-'}</span>)
            },
            {
                Header: 'RA',
                accessor: 'recorrente',
                className: 'text-center pointer',
                width: 60,
                Cell: row => (<span className={`badge badge-${row.value ? 'info' : ''}`}>{row.value ? 'RA' : ''}</span>)
            },
            {
                Header: 'Status pedido',
                accessor: 'statusPedido',
                className: 'text-center pointer',
                width: 110,
                Cell: row => (<span>{row.value}</span>)
                // Cell: row => { return row.value ? (<span className={`badge badge-${this.orderBadgeType(row.value)}`}>{row.value}</span>) : ""}
            },
            {
                Header: 'Status pagto.',
                accessor: 'statusPagto',
                className: 'text-center pointer',
                width: 110,
                Cell: row => (<span className={`badge badge-${this.paymentBadgeType(row.value)}`}>{row.value}</span>)
            },
            {
                Header: 'Produto(s)',
                accessor: 'nomeProduto',
                className: 'text-center pointer',
                Cell: row => (
                    row.value.map((item, index) => {
                        return <p key={index} className="m-0">{item}</p>
                    })
                )
            }
        ];

        this.columnsAvisos = [
            {
                Header: 'idAviso',
                accessor: 'idAviso',
                className: 'text-center pointer',
                width: 100
            },
            {
                Header: 'Item',
                accessor: 'idAvisoItem',
                className: 'text-center pointer',
                width: 100
            },
            {
                Header: 'Data',
                accessor: 'data',
                className: 'text-center pointer',
                width: 180,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Tipo de contato',
                accessor: 'contato',
                className: 'text-center pointer',
                width: 180
            },
            {
                Header: 'Tipo de aviso',
                className: 'text-center pointer',
                width: 180,
                Cell: row => (<span>{row.original.tipoAviso.nome}</span>)
            },
            {
                Header: 'Aberto',
                accessor: 'abriu',
                className: 'text-center pointer',
                width: 180,
                Cell: row => (row.value ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>)
            },
            {
                Header: 'Clicado',
                accessor: 'clicou',
                className: 'text-center pointer',
                Cell: row => (row.value ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>)


            },
        ]

        this.columnsHistoricoUsuario = [
            {
                Header: 'Ação',
                accessor: 'acao',
                className: 'text-center',
                width: 250
            },
            {
                Header: 'Dt. Modificação',
                accessor: 'dtModificacao',
                className: 'text-center',
                Cell: row => (<span>{moment(row.value).format('DD/MM/YYYY')}</span>),
                width: 200
            },
            {
                Header: 'Usuário',
                accessor: 'usuarioModificador',
                className: 'text-center',
                width: 250
            },
            {
                Header: 'Valor Antigo',
                accessor: 'valorAntigo',
                className: 'text-center',
            },
            {
                Header: 'Novo Valor',
                accessor: 'valorAtual',
                className: 'text-center',
            },

        ]

    }

    componentWillMount() {
        this.carregaInfosMembro();
        this.carregarEnderecos();
    }

    carregaInfosMembro() {
        this.setState({ isLoadingDetalhes: true })
        axios.get(this.Configurations.apiBasePath + `/assinante/detalhes/${this.props.match.params.idUsuario}`).then(response => {
            this.getUserBalance();
            console.log("🚀 ~ ClientOrders ~ axios.get ~ response:", response.data)
            this.setState({

                detalhesMembro: response.data.data,
                assinaturasAtivas: response.data.data.assinaturas,
                cile: response.data.data.idCile > 0,
                flagMembro: !!response.data.data.codMembro,
                termoResp: response.data.data.termoResponsabilidade,
                politicaPrivac: response.data.data.politicaPrivacidade,
                dtNascimento: moment(response.data.data.dtNascimento).format('DD/MM/YYYY'),
                email: response.data.data.email,
                inputEmailReenvio: response.data.data.email
            }, () => {
                if (this.state.flagMembro) {
                    this.setState({ isLoadingFamilia: true })
                    axios.get(this.Configurations.apiBasePath + `/membros/${this.state.detalhesMembro.codMembro}/familia`).then(response => {
                        this.setState({
                            listaFamilia: response.data.data.familiares
                        })
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingFamilia: false }));
                }
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingDetalhes: false }));


    }

    tipoBadgeLogin(id) {
        switch (id) {
            case 2:
                return "danger";
            case 3:
                return "primary";
            case 4:
                return "success";
            default:
                return "secondary";
        }

    }

    orderBadgeType(status) {
        switch (status) {
            case "Pedido Feito":
                return "primary";
            case "Aguardando Vigência":
                return "primary";
            case "Vigência em andamento":
                return "primary";
            case "Vencido":
                return "danger";
            case "Pedido Cancelado":
                return "danger";
            default:
                return "warning";
        }
    }

    paymentBadgeType(status) {
        switch (status) {
            case "pago":
                return "success";
            case "vencido":
                return "secondary";
            case "negado":
                return "danger";
            case "Baixa Manual":
                return "primary";
            default: // case 1, 3
                return "warning";
        }
    }

    productBadgeType(sigla) {
        switch (sigla.toLowerCase()) {
            case "bs":
                return "primary";
            case "tc":
                return "danger";
            case "rd":
                return "warning";
            default:
                return "info";
        }
    }


    getUserBalance() {
        this.setState({ loadingBalance: true });

        const _balance = axios.get(this.Configurations.apiBasePath + `/saldo/usuario/${this.props.match.params.idUsuario}`);

        _balance.then(response => {
            this.setState({
                userBalance: response.data.saldo,
                loadingBalance: false
            });
        }).catch(this.handleError)

    }

    // pedidos/idpedido/estorno
    getOrders(o) {
        this.setState({ loadingPedidos: true });

        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 20;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
            o.sorted = []
            _params.push(`ordenacao=${o.sorted.map(item => item.id).join(',')}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        const _orders = axios.get(this.Configurations.apiBasePath + `/pedidos?${_params.join('&')}&idUsuario=${this.props.match.params.idUsuario}`);

        _orders.then(response => {
            this.setState({
                ordersList: response.data.data.pedidos,
                paginasPedidos: response.data.data.paginacao.totalPaginas,
                loadingPedidos: false
            });
        }).catch(this.handleError)
    }

    refreshTable(o) {
        this.getOrders(o);
    }

    refreshTableHistoricoAvisos(a) {
        this.carregaListaHistoricoAvisos(a);
    }

    formataTelefone(_telefone, _tipo) {
        const _temDDD = _telefone.length > 9;

        if (_temDDD) {
            const _numero1 = _telefone.toString().substr(2, _telefone.length - 6);
            const _numero2 = _telefone.toString().substr(_telefone.length - 4, _telefone.length - 1);
            const _ddd = _telefone.toString().substr(0, 2);
            return `(${_ddd}) ${_numero1}-${_numero2}`
        }

        else {
            const _numero1 = _telefone.toString().substr(0, _telefone.length - 4);
            const _numero2 = _telefone.toString().substr(_telefone.length - 4, _telefone.length - 1);
            return `${_numero1}-${_numero2}`
        }
    }

    renderizarStatusContato(confirmado, verificado) {
        if (verificado) {
            return <span className="badge badge-success ml-2">Verificado</span>
        }
        if (confirmado) {
            return <span className="badge badge-lightyellow text-dark ml-2">Confirmado</span>
        }
        return null;
    }

    atualizaDados() {
        this.setState({ isLoadingAtualizacao: true });
        axios.put(this.Configurations.apiBasePath + `/membros/${this.props.match.params.idUsuario}`).then(response => {
            this.carregaInfosMembro();
            this.toggleModalAtualizacao();
        }).catch(this.handleError).finally(() => {
            this.setState({ isLoadingAtualizacao: false });
        });
    }

    toggleModalAtualizacao() { this.setState({ modalAtualizacao: !this.state.modalAtualizacao }) }

    botaoLogarHub() {
        this.setState({ isLoadingLogar: true });
        axios.get(this.Configurations.apiBasePath + `/impersonate-usuario/${this.state.detalhesMembro.idUsuario}`).then(response => {

            window.open(`${this.Configurations.hkWebClient}/sso/ebs/${response.data.tokenUserImpersonate}`, "_blank");

        }).catch(this.handleError).finally(() => {
            this.setState({ isLoadingLogar: false });
        });
    }

    botaoLogarCile() {
        this.setState({ isLoadingLogarCile: true });
        axios.get(this.Configurations.apiBasePath + `/impersonate-usuario/cile/6/${this.state.detalhesMembro.idUsuario}`).then(response => {

            window.open(`${this.Configurations.cileDigitalClient}/account/cile-login?token=${response.data.tokenUserImpersonate}`, "_blank");

        }).catch(this.handleError).finally(() => {
            this.setState({ isLoadingLogarCile: false });
        });
    }



    cadastrarCile() {
        this.setState({ isLoadingAtualizacao: true });
        axios.put(this.Configurations.apiBasePath + `/membros/cile/${this.state.detalhesMembro.codMembro}`).then(response => {
            this.carregaInfosMembro();
            this.toggleModalAtualizacao();
        }).catch(this.handleError).finally(() => {
            this.setState({ isLoadingAtualizacao: false });
        });
    }

    carregaListaHistoricoAvisos(o) {
        this.setState({ isLoadingHistoricoAvisos: true })
        let pagina, tamanhoPagina;
        if (o === undefined) {
            pagina = 0;
            tamanhoPagina = 10;
        }
        else if (!o.pageSize) {
            tamanhoPagina = this.state.limite;
        } else if (!(o.page + 1)) {
            pagina = this.state.pagina;
        } else {
            tamanhoPagina = o.pageSize;
            pagina = o.page;
            this.setState({
                paginaAvisos: pagina,
                limiteAvisos: tamanhoPagina
            })
        }
        const _idUsuario = this.props.match.params.idUsuario,
            _historyNotifications = axios.get(this.Configurations.apiBasePath + `/aviso-vencimento/avisos/usuarios/${_idUsuario}?page=${pagina + 1}&pageSize=${tamanhoPagina}`);

        _historyNotifications.then(response => {
            this.setState({
                listaHistoricoAvisos: response.data.dados,
                paginasHistoricoAvisos: response.data.paginacao.totalPaginas,
            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingHistoricoAvisos: false
        }));
    }

    carregaListaHistoricoUsuario(o) {
        this.setState({ loadingListaHistoricoUsuario: true })
        let pagina, tamanhoPagina;
        if (o === undefined) {
            pagina = 0;
            tamanhoPagina = 10;
        }
        else if (!o.pageSize) {
            tamanhoPagina = this.state.limite;
        } else if (!(o.page + 1)) {
            pagina = this.state.pagina;
        } else {
            tamanhoPagina = o.pageSize;
            pagina = o.page;
            this.setState({
                paginaAcoesUsuario: pagina,
                limiteAcoesUsuario: tamanhoPagina
            })
        }
        axios.get(this.Configurations.apiBasePath + `/usuario/${this.props.match.params.idUsuario}/historico?pagina=${pagina + 1}&qtdItens=${tamanhoPagina}`).then(response => {
            this.setState({
                historicoUsuario: response.data.data,
                paginasHistoricoUsuario: response.data.paginacao.totalPaginas,
                paginaAtual: response.data.paginacao.paginaAtual
            })
        }).catch(this.handleError).finally(() => this.setState({ loadingListaHistoricoUsuario: false }))
    }

    refreshTableHistoricoUsuario(o) {
        this.carregaListaHistoricoUsuario(o);
    }

    handleError(err) {
        this.setState({
            hasError: true, errorMessage: (err.response && err.response.data && !!err.response.data.message) ?
                err.response.data.message : 'Erro inesperado.'
        })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    toggleModalEditarDados() {
        this.setState({
            modalEditarDados: !this.state.modalEditarDados,
            flagDtNascimentoInvalido: false,
            flagEmailInvalido: false
        })
    }


    onChangeInput(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        const _name = e.target.name;
        const _value = e.target.value;
        this.setState({ [_name]: _value }, () => {
            if (_name === "cpfAlterado") {
                this.setState({
                    flagMsgCPFInvalido: !this.validaCPF(this.state.cpfAlterado)
                })
            }
        })
    }

    validacaoDtNascimento(dtNasc) {
        // First check for the pattern
        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dtNasc))
            return false;

        // Parse the date parts to integers
        var parts = dtNasc.split("/");
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month === 0 || month > 12)
            return false;

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    }

    validacaoEmail(inputEmail) {
        const _usuario = inputEmail.substring(0, inputEmail.indexOf("@"));
        const _dominio = inputEmail.substring(inputEmail.indexOf("@") + 1, inputEmail.length);

        if ((_usuario.length >= 1) &&
            (_dominio.length >= 3) &&
            (_usuario.search("@") === -1) &&
            (_dominio.search("@") === -1) &&
            (_usuario.search(" ") === -1) &&
            (_dominio.search(" ") === -1) &&
            (_dominio.search(".") !== -1) &&
            (_dominio.indexOf(".") >= 1) &&
            (_dominio.lastIndexOf(".") < _dominio.length - 1)) {
            return true;
        }
        else return false;
    }

    salvarEdicaoDados() {
        const dtNascimentoValido = this.validacaoDtNascimento(this.state.dtNascimento);
        const emailValido = (this.state.email.trim() === "") ? true : this.validacaoEmail(this.state.email);
        const _dados = dtNascimentoValido * emailValido;
        // const _dados = dtNascimentoValido;


        if (_dados) {
            this.setState({ isLoadingEdicaoDados: true })
            const _salvarEdicaoDados = {
                dtNascimento: moment(this.state.dtNascimento, "DD/MM/YYYY").format('YYYY-MM-DD'),
                email: this.state.email
            }
            axios.put(this.Configurations.apiBasePath + `/membros/${this.props.match.params.idUsuario}/editar-dados`, _salvarEdicaoDados).then(response => {
                this.carregaInfosMembro();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingEdicaoDados: false }));
            this.toggleModalEditarDados();
            this.setState({ temAlteracao: false })

            // } else if (!dtNascimentoValido) {
            //     this.setState({ flagDtNascimentoInvalido: true })
            // }
        } else {
            this.setState({ flagEmailInvalido: true })
        }
    }

    toggleCollapse() {
        this.setState({ isOpen: !this.state.isOpen })
    }


    carregarEnderecos() {
        this.setState({ isLoadingEnderecos: true })
        axios.get(this.Configurations.apiBasePath + `/membros/${this.props.match.params.idUsuario}/enderecos`).then(response => {
            this.setState({
                enderecos: response.data.enderecos
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEnderecos: false }))
    }

    reativarCadastro() {
        this.setState({ isLoadingReativacao: true });
        axios.post(this.Configurations.apiBasePath + `/assinante/reativar/${this.props.match.params.idUsuario}`).then(response => {
            this.carregaInfosMembro();

        }).catch(this.handleError).finally(() => {
            this.setState({ isLoadingReativacao: false });
        });
    }

    toggleModalEndereco() {
        this.setState({ modalEndereco: !this.state.modalEndereco })
    }

    marcarEnderecoPadrao(idEndereco) {
        const index = this.state.enderecos.findIndex(item => item.idEndereco === idEndereco)
        this.setState({ enderecos: update(this.state.enderecos, { [index]: { loadingEnderecoPadrao: { $set: true } } }) });
        axios.post(this.Configurations.apiBasePath + `/enderecos/${idEndereco}/principal/${this.props.match.params.idUsuario}`).then(response => {
            this.carregarEnderecos();
        }).catch(this.handleError).finally(() => {
            this.setState({ enderecos: update(this.state.enderecos, { [index]: { loadingEnderecoPadrao: { $set: false } } }) });
        })
    }

    excluirEndereco(idEndereco) {
        const index = this.state.enderecos.findIndex(item => item.idEndereco === idEndereco)
        this.setState({ enderecos: update(this.state.enderecos, { [index]: { loadingExcluirEndereco: { $set: true } } }) });
        axios.delete(this.Configurations.apiBasePath + `/enderecos/${idEndereco}`).then(response => {
            this.carregarEnderecos();
        }).catch(this.handleError).finally(() => {
            this.setState({ enderecos: update(this.state.enderecos, { [index]: { loadingExcluirEndereco: { $set: false } } }) });
        })
    }

    toggleCollapseSenha() {
        this.setState({ open: !this.state.open })
    }

    toggleModalConfirmarSenha() {
        this.setState({
            modalConfirmarSenha: !this.state.modalConfirmarSenha,
            senhaConfirmada: false,
            flagSenhaGerada: false
        })
    }

    apiGerarSenha() {
        this.setState({ isLoadingSenhaGerada: true })
        axios.get(this.Configurations.apiBasePath + `/usuario/gerador-senha`)
            .then(response => {
                this.setState({
                    sugestaoSenha: response.data.sugestaoSenha
                });
            }).catch(this.handleError).finally(() => this.setState({ isLoadingSenhaGerada: false }))
        this.toggleModalConfirmarSenha();
    }

    reenviarLink() {
        this.setState({ isLoadingReenviarLink: true })
        axios.get(this.Configurations.apiBasePath + `/usuario/esqueci-senha?idUsuario=${this.props.match.params.idUsuario}&email=${this.state.inputEmailReenvio}`)
            .then(response => {
                this.carregaInfosMembro();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingReenviarLink: false }))
    }

    redefinirSenha() {
        this.setState({ isLoadingConfirmarSenha: true })
        const _body = { novaSenha: this.state.sugestaoSenha }
        axios.post(this.Configurations.apiBasePath + `/usuario/redefinir-senha/${this.props.match.params.idUsuario}`, _body)
            .then(response => {
                this.carregaInfosMembro();
                this.setState({
                    modalConfirmarSenha: !this.state.modalConfirmarSenha,
                    senhaConfirmada: true,
                    flagSenhaGerada: true
                })
            }).catch(this.handleError).finally(() => this.setState({ isLoadingConfirmarSenha: false }))
    }

    alterarCPF() {
        this.setState({
            flagAlterarCPF: true,
            sucessoCPFAlterado: false,
        })
    }

    salvarNovoCPF() {
        if (this.validaCPF(this.state.cpfAlterado) !== '') {
            this.setState({ isLoadingSalvarNovoCPF: true })
            let cpfTratado = this.state.cpfAlterado.replaceAll('.', '')
            let cpfTratadoCompleto = cpfTratado.replaceAll('-', '')
            const _body = { cpf: cpfTratadoCompleto }
            axios.put(this.Configurations.apiBasePath + `/usuario/alterar-cpf/${this.props.match.params.idUsuario}`, _body).then(response => {
                this.carregaInfosMembro();
                this.setState({
                    flagAlterarCPF: false,
                    cpfAlterado: '',
                    sucessoCPFAlterado: true,
                    flagMsgCPFInvalido: false
                })
            }).catch(this.handleError).finally(() => this.setState({ isLoadingSalvarNovoCPF: false }))
        } else {
            this.setState({
                flagMsgCPFInvalido: true
            })
        }
    }

    cancelar() {
        this.setState({
            flagAlterarCPF: false,
            cpfAlterado: '',
            flagMsgCPFInvalido: false
        })
    }

    validaCPF(strCPF) {
        let retornoValidacao = true;
        let resto = 0;
        let soma = 0;

        strCPF = strCPF.replaceAll('.', '')
        strCPF = strCPF.replaceAll('-', '')


        if (strCPF.length !== 11) {
            return retornoValidacao = false;
        }

        if (strCPF === "00000000000") {
            retornoValidacao = false
        };
        for (let i = 1; i <= 9; i++) {
            soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        }
        resto = (soma * 10) % 11;

        if ((resto === 10) || (resto === 11)) {
            resto = 0;
        }
        if (resto !== parseInt(strCPF.substring(9, 10))) {
            retornoValidacao = false;
        }

        soma = 0;
        for (let i = 1; i <= 10; i++) {
            soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        }
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) {
            resto = 0;
        }

        if (resto !== parseInt(strCPF.substring(10, 11))) {
            retornoValidacao = false;
        }

        return retornoValidacao;
    }

    mostrarMascaraCPF(cpf) {
        cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
        cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
        cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
        return cpf;
    }

    enviarDadosRightNow() {
        this.setState({ isLoadingEnviarDados: true })
        axios.put(this.Configurations.apiBasePath + `/membros/${this.props.match.params.idUsuario}/externo`).then(response => {
            this.toggleModalDadosEnviados();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEnviarDados: false }))
    }

    toggleModalDadosEnviados() {
        this.setState({ modalDadosEnviados: !this.state.modalDadosEnviados })
    }

    render() {
        const { detalhesMembro, cile } = this.state
        return (
            <div className="row client-order">
                <div className="col-12">
                    <div className="row no-gutters align-items-center">
                        <div className="col-3">
                            <h2 className="title-1 m-0">Dados do usuário</h2>
                        </div>
                        {/* <div className="col-3 text-center">
                            {this.state.isLoadingAtualizacao ? (
                                <div className="spinner-border text-primary" role="status" />
                            ) : (
                                <React.Fragment>
                                    {this.state.flagMembro && (
                                        <button onClick={this.atualizaDados} className="btn btn-outline-success">atualizar dados cadastrais</button>
                                    )}
                                </React.Fragment>
                            )}
                        </div> */}
                        <div className="col-3 text-center">
                            {this.state.isLoadingEnviarDados ? (
                                <div className="spinner-border text-center text-primary" role="status" />
                            ) : (
                                <button className='btn btn-outline-success' onClick={this.enviarDadosRightNow}>enviar dados ao right now</button>
                            )}
                        </div>
                        <div className="col-2 text-right">
                            {this.state.isLoadingLogarCile ? (
                                <div className="spinner-border text-primary" role="status" />
                            ) : (
                                <DivPermission
                                    arrayPerm={[1, 27]}
                                    permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                >
                                    {cile ? (
                                        <button type="button" className="btn btn-outline-orange" onClick={this.botaoLogarCile}>Logar no Cile Digital</button>
                                    ) : (
                                        <React.Fragment></React.Fragment>
                                    )}
                                </DivPermission>
                            )}
                        </div>


                        <div className="col-2 text-right">
                            {this.state.isLoadingLogar ? (
                                <div className="spinner-border text-primary" role="status" />
                            ) : (
                                <button type="button" className="btn btn-outline-primary" onClick={this.botaoLogarHub}>Logar no Hub</button>
                            )}
                        </div>
                        <div className="col-2 text-right">
                            <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                        </div>
                    </div>
                </div>
                {this.state.isLoadingDetalhes ? (
                    <div className="col-12 text-center py-5">
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                ) : (
                    <div className="col-12 py-3">
                        <div className='row'>
                            <div className='col-12'>
                                {detalhesMembro.dtDelete && (
                                    <div className='card text-white bg-danger mb-3'>
                                        <div className='card-header'><strong>Usuário deletado</strong></div>
                                        <div className='card-body'>
                                            Esse usuário solicitou exclusão de seu acesso pelo BS+ no dia {moment(detalhesMembro.dtDelete).format('DD/MM/YYYY')}. Caso essa ação tenha sido por acidente, você pode desfazer no botão abaixo.<br />
                                            <button className='btn btn-danger mt-3' disabled={this.state.isLoadingReativacao} onClick={this.reativarCadastro}>{this.state.isLoadingReativacao ? 'Processando...' : 'Reativar'}</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='row py-2'>
                            <div className='col-6'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <div className='col-12'>
                                            <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleCollapseSenha}>
                                                <i className={`fa mr-2 ${this.state.open ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                                                Alterar senha
                                            </button>
                                        </div>
                                    </div>
                                    <Collapse isOpen={this.state.open}>
                                        <div className='card-body'>
                                            <div className='row py-2'>
                                                <div className='col-12'>
                                                    <p className='m-0'>Para alterar senha, você pode escolher uma das 2 opções: </p>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12 py-2'>
                                                    <p className='m-0'>1 - Reenviar link para redefinição de senha</p>
                                                </div>
                                            </div>
                                            <div className='row text-center'>
                                                <div className='col-6'>
                                                    <input className="form-control" type="email" name="inputEmailReenvio" autoComplete='off' onChange={this.onChangeInput}
                                                        value={this.state.inputEmailReenvio} />
                                                </div>
                                                {this.state.isLoadingReenviarLink ? (
                                                    <div className='col-6'>
                                                        <div className="spinner-border text-primary" role="status" />
                                                    </div>
                                                ) : (
                                                    <div className='col-6'>
                                                        <button className='btn btn-outline-info' onClick={this.reenviarLink}>Reenviar link no email</button>
                                                    </div>
                                                )}
                                            </div>
                                            <div className='row py-2'>
                                                <div className='col-12 text-primary text-center'>
                                                    {this.state.isLoadingReenviarLink && (
                                                        <i><p className='m-0'>Link enviado com sucesso!</p></i>
                                                    )}
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-12 py-2'>
                                                    <p className='m-0'>2 - Gerar nova senha</p>
                                                </div>
                                                {this.state.isLoadingSenhaGerada ? (
                                                    <div className='col-6 text-left'>
                                                        <div className="spinner-border text-primary" role="status" />
                                                    </div>
                                                ) : (
                                                    <div className='col-6 text-left'>
                                                        <button className='btn btn-outline-success' onClick={this.apiGerarSenha}>Gerar senha</button>
                                                    </div>
                                                )}
                                                {this.state.flagSenhaGerada && (
                                                    <div className='col-6 text-center'>
                                                        <strong><p className='m-0'>{this.state.sugestaoSenha}</p></strong>
                                                        <i><p className='m-0 text-success'>Esta é a nova senha</p></i>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Collapse>
                                </div>
                            </div>
                            <div className='col-6 text-center'>

                            </div>
                        </div>


                        <div className="row">
                            <div className="col-6 py-2 pl-3 pr-2">
                                <div className="card">
                                    <div className="card-header">
                                        <strong>Dados Pessoais</strong>
                                    </div >
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 align-items-center">
                                                <div className="row no-gutters align-items-center">
                                                    <div className="col-12 py-2">
                                                        <h5 className="my-0"><b>{this.state.detalhesMembro.nome}</b> {this.state.flagMembro ? `(${this.state.detalhesMembro.codMembro})` : ''}
                                                            <span className="ml-4 badge badge-info text-capitalize">{detalhesMembro.situacao}</span>
                                                            {this.state.flagMembro && (
                                                                <React.Fragment>
                                                                    <span className="ml-2 badge badge-info">{this.state.detalhesMembro.divisao}</span>
                                                                </React.Fragment>
                                                            )}
                                                        </h5>
                                                        <DivPermission
                                                            exclusao={true}
                                                            arrayPerm={[1, 29]}
                                                            permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                        >
                                                            <div className='row no-gutters pt-2'>
                                                                <div className="col-4 pt-3 pr-3">
                                                                    <strong>CPF: </strong>
                                                                    {!!this.state.detalhesMembro.cpf ? (
                                                                        <React.Fragment>
                                                                            {this.state.detalhesMembro.cpf}
                                                                        </React.Fragment>
                                                                    ) : (
                                                                        <React.Fragment>
                                                                            <i>Não cadastrado</i>
                                                                        </React.Fragment>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </DivPermission>

                                                        <div className="row align-items-end no-gutters">
                                                            <DivPermission
                                                                arrayPerm={[1, 29]}
                                                                permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                            >
                                                                {this.state.flagAlterarCPF ? (
                                                                    <div className='row align-items-end'>
                                                                        <div className='col-3 pr-3'>
                                                                            <label><strong>CPF:</strong></label>
                                                                        </div>
                                                                        <div className="col-8 pr-3">
                                                                            <InputMask
                                                                                type="text"
                                                                                className='form-control'
                                                                                maskChar=""
                                                                                mask="999.999.999-99"
                                                                                id="cpfAlterado"
                                                                                name="cpfAlterado"
                                                                                placeholder='Ex: 12345678910'
                                                                                value={this.state.cpfAlterado}
                                                                                onChange={this.onChangeInput}
                                                                                autoComplete='off'
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="col-4 pt-3 pr-3">
                                                                        <strong>CPF: </strong>
                                                                        {!!this.state.detalhesMembro.cpf ? (
                                                                            <React.Fragment>
                                                                                {this.mostrarMascaraCPF(this.state.detalhesMembro.cpf)}
                                                                            </React.Fragment>
                                                                        ) : (
                                                                            <React.Fragment>
                                                                                <i>Não cadastrado</i>
                                                                            </React.Fragment>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {this.state.flagAlterarCPF ? (
                                                                    <React.Fragment>
                                                                        {this.state.isLoadingSalvarNovoCPF ? (
                                                                            <div className='col-2 pt-3'>
                                                                                <div className="spinner-border text-center text-primary" role="status" />
                                                                            </div>
                                                                        ) : (
                                                                            <div className='col-2 pt-3 pr-3'>
                                                                                <button className='btn btn-outline-success' onClick={this.salvarNovoCPF} disabled={this.state.flagMsgCPFInvalido}>Salvar</button>
                                                                            </div>
                                                                        )}
                                                                        <div className='col-2 pt-3'>
                                                                            <button className='btn btn-outline-danger' onClick={this.cancelar}>Cancelar</button>
                                                                        </div>
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <div className='col-3 pt-3 pr-3'>
                                                                        <button className='btn btn-outline-primary' onClick={this.alterarCPF}>Alterar cpf</button>
                                                                    </div>
                                                                )}
                                                                {this.state.sucessoCPFAlterado && (
                                                                    <div className='col-4'>
                                                                        <i><p className='m-0 text-success'>CPF alterado com sucesso!</p></i>
                                                                    </div>
                                                                )}
                                                                {this.state.flagMsgCPFInvalido && (
                                                                    <div className='col-12 text-danger py-2'>
                                                                        <p><i><strong>CPF incompleto ou inválido</strong></i></p>
                                                                    </div>
                                                                )}
                                                            </DivPermission>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`col-12 py-2`}>
                                                <strong>{this.state.detalhesMembro.funcoes && this.state.detalhesMembro.funcoes.length > 1 ? 'Funções:' : 'Função:'} </strong>
                                                {this.state.detalhesMembro.funcoes && this.state.detalhesMembro.funcoes.length > 0 ?

                                                    this.state.detalhesMembro.funcoes.map((item, index) =>
                                                        <span key={`funcao-${index}`}>{item} {index === this.state.detalhesMembro.funcoes.length - 1 ? '' : ' / '}</span>
                                                    )
                                                    : 'Membro'}
                                            </div>
                                            <div className="col-12 py-2">
                                                <strong>Data de nascimento:</strong> {moment(this.state.detalhesMembro.dtNascimento).format('DD/MM/YYYY')}
                                            </div>
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-12 border-top pt-2 mt-2">
                                                        <div className="row">
                                                            <div className="col-6 py-2">
                                                                <strong>{this.state.detalhesMembro.telefones.length > 1 ? 'Telefones:' : 'Telefone:'} </strong>
                                                                {this.state.detalhesMembro.telefones.length > 0 ? (
                                                                    <div className="pl-3">
                                                                        {this.state.detalhesMembro.telefones.map((item, index) =>
                                                                            <div key={`telefone-${index}`} className="d-flex align-items-center py-1">
                                                                                <span>{this.formataTelefone(item.numero)} ({item.tipo})</span>
                                                                                {this.renderizarStatusContato(item.telefoneConfirmado, item.telefoneVerificado)}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ) : <em>Não informado</em>}
                                                            </div>
                                                            <div className="col-6 py-2">
                                                                <strong>{this.state.detalhesMembro.emails && this.state.detalhesMembro.emails.length > 1 ? 'Emails:' : 'Email:'} </strong>
                                                                {this.state.detalhesMembro.emails && this.state.detalhesMembro.emails.length > 0 ? (
                                                                    <div className="pl-3">
                                                                        {this.state.detalhesMembro.emails.map((item, index) =>
                                                                            <div key={`email-${index}`} className="d-flex align-items-center py-1">
                                                                                <a href={`mailto:${item.email}`}>{item.email}</a>
                                                                                {this.renderizarStatusContato(item.emailConfirmado, item.emailVerificado)}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ) : <em>Não informado</em>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-12 border-top pt-2 mt-2">
                                                        <div className='row'>

                                                            {this.state.flagMembro && (
                                                                <React.Fragment>
                                                                    <div className="col-6 py-2 align-items-center d-flex">
                                                                        <strong>Cadastro no CILE:</strong>
                                                                        <span className={`mx-2 badge badge-${cile ? 'primary' : 'danger'}`}>{cile ? 'Sim' : 'Não'}</span>
                                                                        {/* {!cile && <button onClick={this.cadastrarCile} disabled={this.state.isLoadingAtualizacao} className="mx-2 btn btn-sm btn-outline-primary">cadastrar no cile</button>} */}
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                            <div className="col-6 py-2 align-items-center d-flex">
                                                                <strong>Tipo de login:</strong>
                                                                {this.state.detalhesMembro.tiposLogin.length > 0 ?
                                                                    this.state.detalhesMembro.tiposLogin.map((item, index) => {
                                                                        return <span key={`${index}`} className={`badge badge-${this.tipoBadgeLogin(item.idProvider)} px-2 mx-1`}>{item.nome}</span>
                                                                    }) : <em> Não registrado</em>}

                                                            </div>
                                                            {this.state.flagMembro && (
                                                                <React.Fragment>
                                                                    {this.state.detalhesMembro.funcoes.length > 0 && (
                                                                        <div className="col-6 py-2 align-items-center d-flex">
                                                                            <strong>Termo de responsabilidade:</strong>
                                                                            <span className={`mx-2 badge badge-${this.state.termoResp ? 'primary' : 'danger'}`}> {this.state.termoResp ? 'Sim' : 'Não'}</span>
                                                                        </div>
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                            <div className="col-6 py-2 align-items-center d-flex">
                                                                <strong>Política de privacidade:</strong>
                                                                <span className={`mx-2 badge badge-${this.state.politicaPrivac ? 'primary' : 'danger'}`}> {this.state.politicaPrivac ? 'Sim' : 'Não'}</span>
                                                            </div>
                                                            <div className="col-12 py-2 mt-4 text-center">
                                                                <button className="btn btn-outline-success" onClick={this.toggleModalEditarDados}>Editar dados</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div >
                                    </div >
                                </div>
                            </div>
                            {this.state.flagMembro && (
                                <div className="col-6 py-2 pr-3 pl-2">
                                    <div className="card">
                                        <div className="card-header">
                                            <strong>Dados de Organização</strong>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-6 py-2">
                                                    <strong>Coord. Geral:</strong> {this.state.detalhesMembro.organizacao.coordGeral}
                                                </div>
                                                <div className="col-6 py-2">
                                                    <strong>Coordenadoria:</strong> {this.state.detalhesMembro.organizacao.coordenadoria}
                                                </div>
                                                <div className="col-6 py-2">
                                                    <strong>Sub. Coord:</strong> {this.state.detalhesMembro.organizacao.sub}
                                                </div>
                                                <div className="col-6 py-2">
                                                    <strong>RM/RE:</strong> {this.state.detalhesMembro.organizacao.rm}
                                                </div>
                                                {this.state.detalhesMembro.organizacao.area && (
                                                    <div className="col-6 py-2">
                                                        <strong>Área:</strong> {this.state.detalhesMembro.organizacao.area}
                                                    </div>
                                                )}

                                                {this.state.detalhesMembro.organizacao.regional && (
                                                    <div className="col-6 py-2">
                                                        <strong>Regional:</strong> {this.state.detalhesMembro.organizacao.regional}
                                                    </div>
                                                )}
                                                <div className="col-6 py-2">
                                                    <strong>Distrito:</strong> {this.state.detalhesMembro.organizacao.distrito}
                                                </div>
                                                <div className="col-6 py-2">
                                                    <strong>Comunidade:</strong> {this.state.detalhesMembro.organizacao.comunidade}
                                                </div>
                                                <div className="col-6 py-2">
                                                    <strong>Bloco:</strong> {this.state.detalhesMembro.organizacao.bloco}
                                                </div>
                                                {this.state.detalhesMembro.ci.localidadeCI !== null && (
                                                    <div className="col-12 pt-3 border-top">
                                                        <div className="row no-gutters">
                                                            <div className="col-5">
                                                                <h6><span className="badge badge-info">{this.state.detalhesMembro.divisao.includes("DF") ? "Coordenadora de Impresso" : "Coordenador de Impresso"}</span></h6>
                                                            </div>
                                                            <div className="col-7">
                                                                <div className="row no-gutters">
                                                                    <div className="col-12">
                                                                        <strong>Nível: </strong>{this.state.detalhesMembro.ci.nivelNome}
                                                                    </div>
                                                                    <div className="col-12 pt-1">
                                                                        <strong>Localidade: </strong>{this.state.detalhesMembro.ci.localidadeCI}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.detalhesMembro.localEntrega && (
                                                    <div className="col-12 pt-3 mt-2 border-top">
                                                        <div className="row no-gutters">
                                                            <div className="col-12">
                                                                <strong>Local de entrega: </strong>
                                                                <Link to={{ pathname: `/logistica/locais-entrega/detalhes/${this.state.detalhesMembro.localEntrega.idLocalEntrega}` }}>{this.state.detalhesMembro.localEntrega.nomeLocalEntrega}</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-12 mt-0">
                                            <div className="card">
                                                <div className="card-header">
                                                    <strong>Saldo disponível</strong>
                                                </div>
                                                <div className="card-body text-center">
                                                    <h3 className={this.state.userBalance > 0 ? "text-success" : "text-danger"}> R$ {!!this.state.userBalance ? this.state.userBalance.toFixed(2).toString().replace('.', ',') : "0,00"}</h3>
                                                    <button onClick={() => this.props.history.push(`/assinante/saldo-migracao/${this.props.match.params.idUsuario}`)} className="btn btn-outline-info">ver detalhes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.flagMembro && (
                                <div className="col-12 py-3">
                                    <TableFamily
                                        listaFamilia={this.state.listaFamilia}
                                        loading={this.state.isLoadingFamilia}
                                    />
                                </div>
                            )}

                            <div className="col-12 py-2" id="enderecos">
                                <div className="card">
                                    <div className="card-header p-2" id="headingOne">
                                        <div className="col-12">
                                            <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleCollapse}>
                                                <i className={`fa mr-2 ${this.state.isOpen ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                                Endereços
                                            </button>
                                        </div>
                                    </div>


                                    {this.state.isLoadingEnderecos ? (
                                        <div className="col-12 text-center px-3 py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    ) : (
                                        <Collapse isOpen={this.state.isOpen}>
                                            <div className="card-body">
                                                {this.state.enderecos.map((item, index) => {
                                                    return (
                                                        <div className='row' key={index}>
                                                            <div className='col-9'>
                                                                <p key={index}><b>{item.nome}</b> : {item.logradouro}, {item.numero} {item.complemento ? item.complemento : ''} - {item.bairro} - {item.cidade} - {item.uf} - {item.cep} <span className='endereco badge badge-info'>{item.principal ? "Padrão" : ""}</span></p>
                                                            </div>
                                                            {item.loadingExcluirEndereco ? (
                                                                <div className='col-1 text-center'>
                                                                    <div className="spinner-border text-primary" role="status" />
                                                                </div>
                                                            ) : (
                                                                <React.Fragment>
                                                                    {!item.principal && (
                                                                        <div className='col-1 text-center'>
                                                                            <button className='btn btn-sm btn-outline-danger' onClick={() => this.excluirEndereco(item.idEndereco)}>Excluir</button>
                                                                        </div>
                                                                    )}
                                                                </React.Fragment>
                                                            )}

                                                            {item.loadingEnderecoPadrao ? (
                                                                <div className='col-2 text-center'>
                                                                    <div className="spinner-border text-primary" role="status" />
                                                                </div>
                                                            ) : (
                                                                <React.Fragment>
                                                                    {!item.principal && (
                                                                        <div className='col-2 text-center'>
                                                                            <button className='btn btn-sm btn-outline-success' onClick={() => this.marcarEnderecoPadrao(item.idEndereco)}>Marcar como padrão</button>
                                                                        </div>
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    )
                                                })}
                                                <div className='row'>
                                                    <div className='col-3 text-left'>
                                                        <button className='btn btn-outline-secondary' onClick={this.toggleModalEndereco}>Novo endereço</button>
                                                    </div>
                                                </div>
                                                {this.state.enderecos.length <= 0 && (
                                                    <div className="col-12 text-center py-3">
                                                        <p>Não existem endereços cadastrados.</p>
                                                    </div>
                                                )}
                                            </div>
                                        </Collapse>
                                    )}
                                </div>
                            </div>

                            {(!!this.state.assinaturasAtivas.periodico && !!this.state.assinaturasAtivas.cile) && (this.state.assinaturasAtivas.periodico.length > 0 || this.state.assinaturasAtivas.cile.length > 0) && (
                                <div className="col-12 py-2">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className='row'>
                                                <div className='col-4 text-left'>
                                                    <strong>Assinaturas Ativas</strong>
                                                </div>
                                                <div className='col-8 text-right'>
                                                    <span className='ml-3 mr-1 badge badge-lightblue'>S</span>
                                                    <span className=''>= solicitante</span>
                                                    <span className='ml-3 mr-1 badge badge-lightgreen'>B</span>
                                                    <span className=''>= beneficiário</span>
                                                    <span className='ml-3 mr-1 badge badge-success'>RA</span>
                                                    <span className=''>= renovação automática</span>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="card-body">
                                            {this.state.assinaturasAtivas.periodico.length > 0 && (
                                                <div className="row">
                                                    <div className='col-12'>
                                                        <strong><span>PERIÓDICOS</span></strong>
                                                    </div>
                                                    {this.state.assinaturasAtivas.periodico.map((item, index) => {
                                                        return (
                                                            <div key={`assinAtiva-${index}`} className="col-4 py-2">
                                                                <div className="row no-gutters">
                                                                    <div className="assinaturas-ativas col-12 align-items-center d-flex">
                                                                        <div className="row no-gutters">
                                                                            <div className="col-12">
                                                                                <span key={index} className={`badge badge-${Geral.obtemTipoBadge(item.sigla).badgeColor} text-${Geral.obtemTipoBadge(item.sigla).textColorInside} py-1 px-1`}>{item.qtde} {item.nomeProduto}</span>
                                                                                {item.digital && <span className={`badge badge-${Geral.obtemTipoBadge(item.solicitante ? "S" : "B").badgeColor} ml-2`}>{item.solicitante ? "S" : "B"}</span>}
                                                                                {item.recorrente &&
                                                                                    <a href={item.linkExterno} target='_blank' rel="noopener noreferrer">
                                                                                        <span className="badge badge-success mx-2 badge-ra">RA</span>
                                                                                    </a>
                                                                                }
                                                                                <p className='m-0'>
                                                                                    Pedido: <NavLink className="cursor-pointer" to={`/pedidos/detalhes/${item.idPedido}`} >{item.idPedido}
                                                                                    </NavLink>
                                                                                </p>
                                                                                <p className='m-0'>{moment(item.dtInicio).format("DD/MM/YY")} até {moment(item.dtFim).format("DD/MM/YY")}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                // <div className='row border-bottom'/>
                                            )}

                                            {this.state.assinaturasAtivas.cile.length > 0 && (
                                                <React.Fragment>
                                                    <div className="row">
                                                        <div className='col-12'>
                                                            <strong><span className='py-2'>CILE</span></strong>
                                                        </div>
                                                        {this.state.assinaturasAtivas.cile.filter(i => !i.digital).map((item, index) => {
                                                            return (
                                                                <div className='assinaturas-ativas col-4 py-2' key={index}>
                                                                    <span className='badge badge-purple'>{item.nomeProduto}</span>
                                                                    {item.digital && <span className={`badge badge-${Geral.obtemTipoBadge(item.solicitante ? "S" : "B").badgeColor} ml-2`}>{item.solicitante ? "S" : "B"}</span>}
                                                                    <p className='m-0'>
                                                                        Pedido: <NavLink className="cursor-pointer" to={`/pedidos/detalhes/${item.idPedido}`} >{item.idPedido}
                                                                        </NavLink>
                                                                    </p>
                                                                    <p className='m-0'>Criação: {moment(item.dtCriacao).format("DD/MM/YY")}</p>
                                                                    <p className='m-0'>Pagamento: {moment(item.dtPgto).format("DD/MM/YY")}</p>
                                                                    {!!item.idAssinatura && (
                                                                        <p className='m-0'>Assinatura: {item.idAssinatura}</p>
                                                                    )}
                                                                </div>
                                                            )
                                                        })}
                                                        {this.state.assinaturasAtivas.cile.filter(i => i.digital).map((item, index) => {
                                                            return (
                                                                <div className='assinaturas-ativas col-4 py-2' key={index}>
                                                                    <p className='m-0'></p>
                                                                    <span className='badge badge-orange'>{item.nomeProduto}</span>
                                                                    <span className={`badge badge-${Geral.obtemTipoBadge(item.solicitante ? "S" : "B").badgeColor} ml-2`}>{item.solicitante ? "S" : "B"}</span>
                                                                    <p className='m-0'>
                                                                        Pedido: <NavLink className="cursor-pointer" to={`/pedidos/detalhes/${item.idPedido}`} >{item.idPedido}
                                                                        </NavLink>
                                                                    </p>
                                                                    <p className='m-0'>{moment(item.dtInicio).format("DD/MM/YY")} até {moment(item.dtFim).format("DD/MM/YY")}</p>
                                                                    {/* <p className='m-0'>Assinatura: <a className="cursor-pointer" href=" ">{item.idAssinatura}</a></p> */}
                                                                    <p className='m-0'>Assinatura: {item.idAssinatura}</p>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </React.Fragment>
                                            )}

                                        </div>

                                    </div>
                                </div>
                            )}


                            <div className="col-12 text-center pt-4">
                                <h6>Histórico de pedidos</h6>
                            </div>
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body p-0">
                                        <ReactTable
                                            data={this.state.ordersList}
                                            columns={this.columnsPedidos}
                                            onFetchData={this.refreshTable}
                                            defaultPageSize={20}
                                            pages={this.state.paginasPedidos}
                                            manual
                                            loading={this.state.loadingPedidos}
                                            className="-striped -highlight"
                                            headerClassName="ebs-table-header"
                                            previousText='Anterior'
                                            nextText='Próximo'
                                            loadingText='Carregando...'
                                            noDataText='Nenhum pedido encontrado.'
                                            pageText='Página'
                                            ofText='de'
                                            rowsText='linhas'
                                            getTrProps={(state, rowInfo, column, instance) => {
                                                return {
                                                    onClick: (e, handleOriginal) => {
                                                        this.props.history.push(`/pedidos/detalhes/${rowInfo.original.numeroPedido}`)
                                                    }
                                                }
                                            }}

                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-center pt-4">
                                <h6>Histórico do usuário</h6>
                            </div>
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body p-0">
                                        <ReactTable
                                            data={this.state.historicoUsuario}
                                            columns={this.columnsHistoricoUsuario}
                                            onFetchData={this.refreshTableHistoricoUsuario}
                                            defaultPageSize={10}
                                            pages={this.state.paginasHistoricoUsuario}
                                            manual
                                            loading={this.state.loadingListaHistoricoUsuario}
                                            className="-striped -highlight"
                                            headerClassName="ebs-table-header"
                                            previousText='Anterior'
                                            nextText='Próximo'
                                            loadingText='Carregando...'
                                            noDataText='Nenhum histórico de ação.'
                                            pageText='Página'
                                            ofText='de'
                                            rowsText='linhas'
                                        />
                                    </div>
                                </div>
                            </div>
                            <DivPermission
                                arrayPerm={[1, 19]}
                                permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}

                            >
                                <div className="col-12 text-center pt-4 mt-4">
                                    <h6>Histórico de avisos</h6>
                                </div>
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <ReactTable
                                                data={this.state.listaHistoricoAvisos}
                                                columns={this.columnsAvisos}
                                                onFetchData={this.refreshTableHistoricoAvisos}
                                                defaultPageSize={10}
                                                pages={this.state.paginasHistoricoAvisos}
                                                manual
                                                loading={this.state.loadingHistoricoAvisos}
                                                className="-striped -highlight"
                                                headerClassName="ebs-table-header"
                                                previousText='Anterior'
                                                nextText='Próximo'
                                                loadingText='Carregando...'
                                                noDataText='Nenhum aviso encontrado.'
                                                pageText='Página'
                                                ofText='de'
                                                rowsText='linhas'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </DivPermission>


                        </div>

                    </div>
                )
                }
                <Modal isOpen={this.state.modalAtualizacao} toggle={this.toggleModalAtualizacao}>
                    <ModalHeader toggle={this.toggleModalAtualizacao}>Dados cadastrais</ModalHeader>
                    <ModalBody>
                        <p className="m-0">Atualização realizada com sucesso!</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleModalAtualizacao}>ok</Button>
                    </ModalFooter>
                </Modal>
                {
                    !this.state.isLoadingDetalhes && (
                        <Modal isOpen={this.state.modalEditarDados} toggle={this.toggleModalEditarDados}>
                            <ModalHeader toggle={this.toggleModalEditarDados}>Editar dados</ModalHeader>
                            <ModalBody>
                                <div className="row">
                                    <div className="col-6 p-3">
                                        <label>Data de nascimento</label>
                                        <InputMask
                                            type="tel"
                                            className="form-control"
                                            maskChar=""
                                            mask="99/99/9999"
                                            id="numDtNascimento"
                                            name="dtNascimento"
                                            placeholder="DD/MM/AAAA"
                                            value={this.state.dtNascimento}
                                            onChange={this.onChangeInput}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 p-3">
                                        <label>Email</label>
                                        <input className="form-control" type="email" name="email" autoComplete="off" onChange={this.onChangeInput} value={this.state.email}></input>
                                    </div>
                                </div>
                                {this.state.isLoadingEdicaoDados ? (
                                    <div className="col-12 text-center px-3">
                                        <div className="spinner-border text-primary " role="status" />
                                    </div>
                                ) : (
                                    <div className="col-12 text-center">
                                        <button className="btn btn-outline-success" onClick={this.salvarEdicaoDados} disabled={!this.state.temAlteracao}>Salvar</button>
                                    </div>
                                )}
                                {this.state.flagDtNascimentoInvalido && (
                                    <div className="col-12 py-3 text-center text-danger">
                                        <i>Data de nascimento inválido</i>
                                    </div>
                                )}
                                {this.state.flagEmailInvalido && (
                                    <div className="col-12 py-2 text-center text-danger">
                                        <i>Email inválido</i>
                                    </div>
                                )}
                            </ModalBody>
                        </Modal>
                    )
                }
                <Modal isOpen={this.state.modalConfirmarSenha} toggle={this.toggleModalConfirmarSenha}>
                    <ModalHeader toggle={this.toggleModalConfirmarSenha}>Confirmação de nova senha</ModalHeader>
                    <ModalBody>
                        <p>A senha atual será substituída por <strong>{this.state.sugestaoSenha}</strong>.</p>
                        <p>Deseja confirmar essa substituição?</p>
                        <p>Essa ação não poderá ser revertida.</p>
                        <div className='row text-center'>
                            {this.state.isLoadingConfirmarSenha ? (
                                <div className='col-6'>
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            ) : (
                                <div className='col-6'>
                                    <button className='btn btn-outline-success' onClick={this.redefinirSenha}>Confirmar</button>
                                </div>
                            )}
                            <div className='col-6'>
                                <button className='btn btn-outline-secondary' onClick={this.toggleModalConfirmarSenha}>Voltar</button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.modalDadosEnviados} toggle={this.toggleModalDadosEnviados}>
                    <ModalHeader toggle={this.toggleModalDadosEnviados}>Envio de dados ao Right Now</ModalHeader>
                    <ModalBody>
                        <p className='m-0 text-success text-center'><i><strong>Dados enviados com sucesso!</strong></i></p>
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-outline-secondary' onClick={this.toggleModalDadosEnviados}>ok</button>
                    </ModalFooter>
                </Modal>
                <ModalEndereco
                    toggle={this.toggleModalEndereco}
                    isOpen={this.state.modalEndereco}
                    carregarEnderecos={this.carregarEnderecos}
                    idUsuario={this.props.match.params.idUsuario}
                />
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    // direcionaURL={'/conteudo'}
                    goBack={false}
                />
            </div >
        )
    }

}

export default ClientOrders;